<script setup lang="ts">
defineProps({
	size: {
		type: String,
		default: "40px",
	},
});
</script>

<template>
	<div class="wrapper_loader">
		<div class="loader" :style="{width: size}"></div>
	</div>
</template>

<style lang="scss">
  @use './loader.scss';
</style>
